import API from "./api";

const PaysService = {
  getAll: async () => {
    const response = await API.get("/pays");
    return response.data.donnees;
  },

  getById: async (id: number) => {
    const response = await API.get(`/pays/${id}`);
    return response.data.donnees;
  },

  create: async (payload: any) => {
    const response = await API.post("/pays", payload);
    return response.data.donnees;
  },

  update: async (id: number, payload: any) => {
    const response = await API.put(`/pays/${id}`, payload);
    return response.data.donnees;
  },

  delete: async (id: number) => {
    const response = await API.delete(`/pays/${id}`);
    return response.data.donnees;
  },
};

export default PaysService;
